module.exports = __webpack_public_path__ + "static/08-e9749e8652cf9c22231c82d395c278d1.png";